import item from './item'

const dataMontono2 = [
    {
        img: item.item150,
        id: 'x-bomb-fire',
    },
    {
        img: item.item149,
        id: '5-wild-crown',
    },
    {
        img: item.item148,
        id: 'double-crown-deluxe',
    },
    {
        img: item.item147,
        id: 'x-wild-pumpkin',
    },
    {
        img: item.item146,
        id: 'double-wild-heart-halloween',
    },
    {
        img: item.item145,
        id: 'wild-crown-1000',
    },
    {
        img: item.item144,
        id: 'multi-heart-10',
    },
    {
        img: item.item143,
        id: '10-crown-deluxe',
    },
    {
        img: item.item142,
        id: 'wild-heart-1000',
    },
    {
        img: item.item141,
        id: '10-heart-deluxe',
    },
    {
        img: item.item140,
        id: 'clover-fire-1000',
    },
    {
        img: item.item139,
        id: 'x-crown-fire',
    },
    {
        img: item.item138,
        id: 'lucky-lucky-bells',
    },
    {
        img: item.item137,
        id: 'x-chilli-hot',
    },
    {
        img: item.item136,
        id: 'multi-crown-5',
    },
    {
        img: item.item135,
        id: '10-clover-deluxe',
    },
    {
        img: item.item134,
        id: 'crown-deluxe-2x',
    },
    {
        img: item.item133,
        id: '5-crown-deluxe',
    },
    {
        img: item.item132,
        id: 'x-wild-heart',
    },
    {
        img: item.item131,
        id: 'cosmic-fruits',
    },
    {
        img: item.item130,
        id: 'heart-deluxe-2x',
    },
    {
        img: item.item129,
        id: '5-clover-deluxe',
    },
    {
        img: item.item128,
        id: 'x-wild-crown',
    },
    {
        img: item.item127,
        id: 'pure-hot-5',
    },
    {
        img: item.item126,
        id: 'clover-deluxe-2x',
    },
    {
        img: item.item125,
        id: '5-heart-deluxe',
    },
    {
        img: item.item124,
        id: 'fruit-fire',
    },
    {
        img: item.item123,
        id: 'x-clover-fire',
    },
    {
        img: item.item122,
        id: '5-clover-fire-blast',
    },
    {
        img: item.item121,
        id: 'dice-drop-10',
    },
    {
        img: item.item120,
        id: '5-bell-fire',
    },
    {
        img: item.item119,
        id: 'clover-rush-5',
    },
    {
        img: item.item118,
        id: 'joker-x5',
    },
    {
        img: item.item117,
        id: 'multi-clover-5',
    },
    {
        img: item.item116,
        id: 'respin-fortune',
    },
    {
        img: item.item115,
        id: 'double-wild-diamond',
    },
    {
        img: item.item114,
        id: 'cupids-wild-hearts',
    },
    {
        img: item.item113,
        id: 'rolling-hearts-10',
    },
    {
        img: item.item112,
        id: 'inferno-hot-40',
    },
    {
        img: item.item111,
        id: 'double-clover-fire-christmas',
    },
    {
        img: item.item110,
        id: '5-wild-diamond',
    },
    {
        img: item.item109,
        id: '9-of-a-kind',
    },
    {
        img: item.item108,
        id: 'respin-gems',
    },
    {
        img: item.item107,
        id: 'chilli-double-40',
    },
    {
        img: item.item106,
        id: 'crown-royale',
    },
    {
        img: item.item105,
        id: 'crown-blast-40',
    },
    {
        img: item.item104,
        id: 'inferno-hot-20',
    },
    {
        img: item.item103,
        id: 'chilli-hot-40',
    },
    {
        img: item.item102,
        id: '20-wild-heart',
    },
    {
        img: item.item101,
        id: 'multi-heart-5',
    },
    {
        img: item.item100,
        id: 'clover-field-40',
    },
    {
        img: item.item99,
        id: '10-wild-crown-halloween',
    },
    {
        img: item.item98,
        id: '5-clover-fire-halloween',
    },
    {
        img: item.item97,
        id: 'double-wild-heart',
    },
    {
        img: item.item96,
        id: '777-extra-chance',
    },
    {
        img: item.item95,
        id: 'sevens-heaven',
    },
    {
        img: item.item94,
        id: '10-extra-bank',
    },
    {
        img: item.item93,
        id: '5-clover-fire-6-reels',
    },
    {
        img: item.item92,
        id: 'crown-drop',
    },
    {
        img: item.item91,
        id: 'reel-x27',
    },
    {
        img: item.item90,
        id: 'heart-royale',
    },
    {
        img: item.item89,
        id: 'double-crown-5',
    },
    {
        img: item.item88,
        id: '40-wild-crown',
    },
    {
        img: item.item87,
        id: '777-expand',
    },
    {
        img: item.item86,
        id: 'double-wild-crown',
    },
    {
        img: item.item85,
        id: 'multi-crown-10',
    },
    {
        img: item.item84,
        id: 'clover-drop',
    },
    {
        img: item.item83,
        id: '5-star-fire',
    },
    {
        img: item.item82,
        id: 'bonus-stars',
    },
    {
        img: item.item81,
        id: '40-joker-fire',
    },
    {
        img: item.item80,
        id: '10-wild-heart',
    },
    {
        img: item.item79,
        id: 'sticky-tiki',
    },
    {
        img: item.item78,
        id: 'hot-rush-triple-star',
    },
    {
        img: item.item77,
        id: 'sweet-respins',
    },
    {
        img: item.item76,
        id: 'farm-fiesta',
    },
    {
        img: item.item75,
        id: 'reel-x5',
    },
    {
        img: item.item73,
        id: 'multi-clover-10',
    },
    {
        img: item.item74,
        id: 'divine-strike',
    },
    {
        img: item.item72,
        id: 'star-chaser',
    },
    {
        img: item.item71,
        id: 'eternal-hearts-10',
    },
    {
        img: item.item70,
        id: 'clover-royale',
    },
    {
        img: item.item69,
        id: 'cosmic-sevens',
    },
    {
        img: item.item68,
        id: 'funky-fruits',
    },
    {
        img: item.item67,
        id: 'christmas-delight',
    },
    {
        img: item.item66,
        id: 'juicy-heat-20',
    },
    {
        img: item.item65,
        id: '27-double-fruits',
    },
    {
        img: item.item63,
        id: 'only-anime',
    },
    {
        img: item.item64,
        id: '10-clover-fire',
    },
    {
        img: item.item62,
        id: '81-double-magic',
    },
    {
        img: item.item61,
        id: 'spooky-spins',
    },
    {
        img: item.item60,
        id: '5-wild-fire',
    },
    {
        img: item.item59,
        id: 'volcano-hot',
    },
    {
        img: item.item58,
        id: 'volcano-crown',
    },
    {
        img: item.item57,
        id: '100-clover-fire',
    },
    {
        img: item.item56,
        id: 'dice-double',
    },
    {
        img: item.item55,
        id: 'double-clover-fire',
    },
    {
        img: item.item54,
        id: '81-vegas-crown',
    },
    {
        img: item.item53,
        id: 'apollo-27-classic',
    },
    {
        img: item.item52,
        id: 'spin-up',
    },
    {
        img: item.item51,
        id: 'hot-rush-fruit-lines',
    },
    {
        img: item.item50,
        id: 'book-of-scorpio',
    },
    {
        img: item.item49,
        id: 'hot-rush-both-ways',
    },
    {
        img: item.item48,
        id: 'caps-and-crowns',
    },
    {
        img: item.item47,
        id: '5-clover-fire-lnc',
    },
    {
        img: item.item46,
        id: 'hot-rush-stars-deluxe',
    },
    {
        img: item.item45,
        id: 'slot-royale',
    },
    {
        img: item.item44,
        id: 'lady-triple-fortune',
    },
    {
        img: item.item43,
        id: 'hot-rush-crown-burst',
    },
    {
        img: item.item42,
        id: 'chilli-double',
    },
    {
        img: item.item37,
        id: 'jolly-presents',
    },
    {
        img: item.item39,
        id: '20-wild-crown',
    },
    {
        img: item.item38,
        id: 'wild-trail',
    },
    {
        img: item.item40,
        id: '40-jokers-free-games',
    },
    {
        img: item.item41,
        id: 'moon-dog',
    },
    {
        img: item.item36,
        id: 'wild-heart-beat',
    },
    {
        img: item.item35,
        id: '40-fruit-frenzy',
    },
    {
        img: item.item34,
        id: '20-fruit-frenzy',
    },
    {
        img: item.item33,
        id: 'chilli-hot-5',
    },
    {
        img: item.item32,
        id: '40-hot-joker',
    },
    {
        img: item.item31,
        id: 'fear-of-dark',
    },
    {
        img: item.item30,
        id: 'clover-blast-5',
    },
    {
        img: item.item29,
        id: 'hot-hot',
    },
    {
        img: item.item28,
        id: 'blazing-heat',
    },
    {
        img: item.item27,
        id: 'heat-double',
    },
    {
        img: item.item26,
        id: 'super-lucky',
    },
    {
        img: item.item25,
        id: '40-fire-cash',
    },
    {
        img: item.item23,
        id: '20-fire-cash',
    },
    {
        img: item.item22,
        id: '10-wild-santa',
    },
    {
        img: item.item21,
        id: '5-crown-fire',
    },
    {
        img: item.item20,
        id: 'heat-classic-5',
    },
    {
        img: item.item19,
        id: 'book-of-dread',
    },
    {
        img: item.item18,
        id: '10-wild-pumpkin',
    },
    {
        img: item.item17,
        id: 'clover-coin',
    },
    {
        img: item.item2,
        id: '10-wild-crown',
    },
    {
        img: item.item1,
        id: 'mayan-coins',
    },
    {
        img: item.item3,
        id: '40-cash-bells',
    },
    {
        img: item.item4,
        id: '40-clover-fire',
    },
    {
        img: item.item5,
        id: 'action-hot-20',
    },
    {
        img: item.item6,
        id: 'lost-book',
    },
    {
        img: item.item7,
        id: '5-wild-heart',
    },
    {
        img: item.item8,
        id: '40-dice-fire',
    },
    {
        img: item.item9,
        id: '10-wild-diamond',
    },
    {
        img: item.item10,
        id: 'action-hot-40',
    },
    {
        img: item.item11,
        id: '5-clover-fire',
    },
    {
        img: item.item12,
        id: '5-dice-fire',
    },
    {
        img: item.item13,
        id: '50-wild-cash',
    },
    {
        img: item.item14,
        id: '40-wild-dice',
    },
    {
        img: item.item15,
        id: '40-wild-clover',
    },
    {
        img: item.item16,
        id: '10-wild-dice',
    },
];

export default dataMontono2;